var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'language-flag': _vm.lang != '', 'language-current': _vm.lang == '' },attrs:{"class":_vm.lang},on:{"click":function($event){return _vm.setLanguage()}}},[_c('div',{staticClass:"lang-icon",domProps:{"innerHTML":_vm._s(_vm.langIcon())}}),_vm._v(" "),_c('div',{staticClass:"lang-name",domProps:{"innerHTML":_vm._s(_vm.langName())}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f5038d72","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Graphics/Flags.vue
// module id = null
// module chunks = 